import { eWorkOrderState } from '../../../enums/eWorkOrderState'

export const DEFAULT_WORKORDER_STATE_ORDER = [
  `${eWorkOrderState.CREATED}`,
  `${eWorkOrderState.ON_MASSIVE_PROCESS}`,
  `${eWorkOrderState.AVAILABLE_FOR_PICKING}`,
  `${eWorkOrderState.AVAILABLE_FOR_EXTERNAL_PICKING}`,
  `${eWorkOrderState.ON_PICKING_ROUTE}`,
  `${eWorkOrderState.PICKING_FINISHED}`,
  `${eWorkOrderState.ON_VALIDATION}`,
  `${eWorkOrderState.VALIDATION_FINISHED}`,
  `${eWorkOrderState.ON_PREDISPATCH}`,
  `${eWorkOrderState.DISPATCHED}`,
  `${eWorkOrderState.CANCELED}`,
  `${eWorkOrderState.CAPTURE_VAS_SERVICE}`
]
